import { useEffect } from 'react';

const useWheel = (ref, callback) => {
  const handleWheel = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('wheel', handleWheel);

    return () => {
      document.removeEventListener('wheel', handleWheel);
    };
  });
};

export default useWheel;
